import React from "react";
import styles from './footer.module.css';
import { AiFillYoutube, AiOutlineTwitter, AiFillLinkedin, AiFillMail, AiFillInstagram } from "react-icons/ai"
import { Link, useLocation } from "react-router-dom";


function Footer() {
  const location = useLocation();

  // Hide full footer content on UserSection (/dashboard/*, /codebox) and AdminSection (/admin/*) pages
  const isInternalPage =
    location.pathname.startsWith('/dashboard') ||
    location.pathname.startsWith('/admin') ||
    location.pathname.startsWith('/codebox');

  // On internal pages, render only the sub-footer
  if (isInternalPage) {
    return (
      <footer className={styles.footer}>
        {/* Sub Footer Only */}
        <div className={styles.subFooter}>
          <div className={styles.subFooterRow}>
            <div className={styles.subFooterLeft}>
              <div className={styles.termsLinks}>
                <p>
                  <Link to="/privacy">Privacy</Link> |
                  <Link to="/terms">Terms</Link> |
                  <Link to="/contact">Support</Link>
                </p>
              </div>
            </div>
            <div className={styles.subFooterRight}>
              <div className={styles.copyright}>
                <p>&copy; 2025 SiliconLogix. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerContainer}>
          <div className={styles.footerGrid}>
            {/* Company Info Section */}
            <div className={styles.columnCompanyInfo}>
              <div className={styles.companySection}>
                <div className={styles.logoWrapper}>
                  <img src="/static_img/weblogo.png" alt="SiliconLogiX" />
                </div>
                {/* <div className={styles.companyName}>
                  SOCIETY FOR INTEGRATED LEARNING OF INTEGRATED CIRCUIT, COMMUNICATION AND NETWORKING SYSTEMS
                </div> */}
                <p className={styles.companyDescription}>
                  Empowering electronics & hardware engineers with an interactive learning platform and tools for hands-on learning across VLSI, IoT, Embedded Systems, and other Digital Systems.
                </p>
                <div className={styles.socialIcons}>
                  <ul className={styles.socialNetwork}>
                    <li>
                      <a
                        href="https://www.linkedin.com/company/silicon_logix_in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="LinkedIn"
                      >
                        <AiFillLinkedin size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/siliconlogix/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Instagram"
                      >
                        <AiFillInstagram size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/siliconlogix"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Youtube"
                      >
                        <AiFillYoutube size={22} />
                      </a>
                    </li>
                    {/* <li>
                      <a
                        href="mailto:contact@siliconlogix.in"
                        title="Email Us"
                      >
                        <AiFillMail size={22} />
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>

            {/* Quick Links Section */}
            <div className={styles.columnQuickLinks}>
              <div className={styles.quickLinksSection}>
                <h6>Quick Links</h6>
                <ul className={styles.linkList}>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/learning">Learning</Link></li>
                  <li><Link to="/pricing">Pricing</Link></li>
                  <li><Link to="/notice">Notice Board</Link></li>
                  <li><Link to="/contact">Contact Us</Link></li>
                </ul>
              </div>
            </div>

            {/* Resources Section */}
            <div className={styles.columnResources}>
              <div className={styles.quickLinksSection}>
                <h6>Resources</h6>
                <ul className={styles.linkList}>
                  <li><Link to="/clubs">Clubs</Link></li>
                  <li><Link to="/coreteam">Core Team</Link></li>
                  <li><Link to="/dashboard/learning">Learning</Link></li>
                  <li><Link to="/dashboard/codebox">Code Editor</Link></li>
                  <li><Link to="/privacy">Privacy Policy</Link></li>
                  <li><Link to="/terms">Terms</Link></li>
                </ul>
              </div>
            </div>

            {/* Contact Info Section */}
            <div className={styles.columnContactInfo}>
              <div className={styles.contactSection}>
                <h6>Contact Info</h6>
                <div className={styles.contactInfo}>
                  <div className={styles.contactItem}>
                    <i className={`fa fa-map-marker ${styles.contactIcon}`}></i>
                    <span>Kadubeeshanahalli, Outer Ring Road, Bangalore - 560103, Karnataka, India</span>
                  </div>
                  <div className={styles.contactItem}>
                    <i className={`fa fa-phone ${styles.contactIcon}`}></i>
                    <a href="tel:+918400134829">+91 8400134829</a>
                  </div>
                  <div className={styles.contactItem}>
                    <i className={`fa fa-envelope ${styles.contactIcon}`}></i>
                    <a href="mailto:contact@siliconlogix.in">contact@siliconlogix.in</a>
                  </div>
                  <div className={styles.contactItem}>
                    <i className={`fa fa-clock-o ${styles.contactIcon}`}></i>
                    <span>Mon-Fri: 9:00 AM - 6:00 PM IST</span>
                  </div>
                </div>
                <div className={styles.contactNote}>
                  <i className="fa fa-info-circle"></i> We respond within 12 hours
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sub Footer */}
      <div className={styles.subFooter}>
        <div className={styles.subFooterRow}>
          <div className={styles.subFooterLeft}>
            <div className={styles.termsLinks}>
              <p>
                <Link to="/privacy">Privacy</Link> |
                <Link to="/terms">Terms</Link> |
                <Link to="/contact">Support</Link>
              </p>
            </div>
          </div>
          <div className={styles.subFooterRight}>
            <div className={styles.copyright}>
              <p>&copy; 2025 SiliconLogix. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
